module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.lunsfordridgefarm.com"},
    },{
      plugin: require('../node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Lunsford Ridge Farm","start_url":"/","icon":"src/assets/favicon.png","background_color":"#ffffff","theme_color":"#C98049","display":"browser","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"3836b6380445e33130e811a635992243"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
